const config = {
  // Base URL for auth and non-API endpoints (without /api)
  baseUrl: process.env.REACT_APP_BASE_URL || 'http://localhost:3000',
  // API URL for API endpoints (with /api suffix)
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:3000/api',
  wsUrl: process.env.REACT_APP_WS_URL || 'http://localhost:3000'
};

export default config;